import {AxiosError} from 'axios';
import {POST_NON_NATIONAL_RESULTS_IMPORT_PRESIGNED_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PostUploadPresignedUrlRequest, PresignedUrlResponse} from '../../models/PresignedUrl';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUploadPresignedUrl = ({onSuccess, onError}: Input) => {
  const postUploadPresignedUrl = async (payload: PostUploadPresignedUrlRequest) => {
    const res = await axiosClient.post<PresignedUrlResponse>(
        POST_NON_NATIONAL_RESULTS_IMPORT_PRESIGNED_URL(),
        {
          fileName: payload.fileName,
        }
    );
    return res.data;
  };

  return useCustomMutation(postUploadPresignedUrl, {
    onSuccess,
    onError,
  });
};
